/**
 * All possible reward types that can be found in chests
 */
export enum RewardId {
  GOLD = 'GOLD',
  TORCH = 'TORCH',
  GOLDEN_KEY = 'GOLDEN_KEY',
  GRAY_KEY = 'GRAY_KEY',
  EXPLOSION = 'EXPLOSION',
  NOTHING = 'NOTHING',
}

/**
 * Result of rolling for a reward (what the player actually receives)
 */
export interface RewardResult {
  /** The reward type received */
  id: RewardId;

  /** The actual amount received (after random roll if applicable) */
  amount: number;
}